import React from "react";

function normalizePairToTradingViewSymbol(pair) {
  // "BTC/USD" -> "BTCUSD", "avax / usd" -> "AVAXUSD"
  if (!pair) return "";
  return pair.replace("/", "").replace(/\s+/g, "").toUpperCase();
}

function getTokenSymbol(pair) {
  // "BTC/USD" -> "BTC", "avax / usd" -> "AVAX"
  if (!pair) return "";
  return pair.split("/")[0].replace(/\s+/g, "").toUpperCase();
}

function generateChartUrl(pair, portfolioType, isTestnet) {
  const symbol = normalizePairToTradingViewSymbol(pair);
  const token = getTokenSymbol(pair);
  
  // If portfolio type is Hyperliquid, use Hyperliquid chart links
  if (portfolioType === "HYPERLIQUID") {
    const baseUrl = isTestnet 
      ? "https://app.hyperliquid-testnet.xyz" 
      : "https://app.hyperliquid.xyz";
    return `${baseUrl}/trade/${token}`;
  }
  
  // Default to TradingView for paper trading and other portfolio types
  return `https://www.tradingview.com/symbols/${symbol}/`;
}

export function TradingViewResearch({ 
  pair = "BTC/USD", 
  portfolioType = null, 
  isTestnet = false 
}) {
  const symbol = normalizePairToTradingViewSymbol(pair);
  const baseUrl = generateChartUrl(pair, portfolioType, isTestnet);
  const newsUrl = `https://www.tradingview.com/symbols/${symbol}/news/`;

  return (
    <div className="mb-2 flex items-center gap-2 flex-row">
      <span className="text-xs text-slate-300">
        Research: <span className="font-mono">{pair}</span>
      </span>

      <a
        href={baseUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-cyan-700/30 hover:bg-cyan-700/50 text-slate-300 text-xs font-medium py-1 px-2 rounded-lg transition-colors"
      >
        View Chart
      </a>

      <a
        href={newsUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-cyan-700/30 hover:bg-cyan-700/50 text-slate-300 text-xs font-medium py-1 px-2 rounded-lg transition-colors"
      >
        View News
      </a>
    </div>
  );
}
